import type { Span, SpanOptions } from "@elastic/apm-rum";
import { otto } from "@gr-exports/head/nexus";
import { toggle } from "@gr-exports/head/toggle";

const { startSpan } = otto.apm;

/**
 *
 *
 */
export interface RunWithSpanOptions extends SpanOptions {
  /**
 *
 */
  labels?: Labels | null;
}

/**
 *
 */
const TOGGLE_SPAN_INSTRUMENTATION_PREFIX = "gr_apm_instrument_span_";

/**
 *
 */
const DEFAULT_SPAN_TYPE = "app.function.invoke";

/**
 *
 *
 *
 *
 *
 */
export const isSpanInstrumentationDisabled = (spanType: string): boolean => {
  const toggleName = spanType.toLowerCase().replace(/[-_.]/g, "_");
  return !toggle.get(TOGGLE_SPAN_INSTRUMENTATION_PREFIX + toggleName, true);
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*                                                          */
export const runWithSpan = async <N extends string, T extends string, A extends unknown[], R>(
  fn: (this: Span | undefined, ...args: A) => R | PromiseLike<R>,
  name: N,
  type: T = DEFAULT_SPAN_TYPE as T,
  options: RunWithSpanOptions = {},
  ...fnArgs: A
): Promise<Awaited<R>> => {
  if (isSpanInstrumentationDisabled(type)) {
    /*                                                         */
    /*                                     */
    return fn.apply(undefined, fnArgs) as never;
  }

  const { labels, ...spanOptions } = options;
  const span = await startSpan(name, type, { blocking: true, ...spanOptions });

  /*                                */
  if (!span) return fn.apply(span, fnArgs) as never;

  /*                                */
  if (labels && typeof labels === "object") span.addLabels(labels);

  try {
    /*                                                       */
    return await fn.apply(span, fnArgs);
  } finally {
    span.end();
  }
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const withSpan =
  /*                                                          */
  <N extends string, T extends string, A extends any[], R>(
    fn: (this: Span | undefined, ...args: A) => R | PromiseLike<R>,
    name: N,
    type: T = DEFAULT_SPAN_TYPE as T,
    options: RunWithSpanOptions = {},
  ): ((...args: A) => Promise<Awaited<R>>) =>
    isSpanInstrumentationDisabled(type)
      ? /*                                     */
        (...args: A) => fn.apply(undefined, args) as never
      : (...args: A) => runWithSpan(fn, name, type, options, ...args);
